import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Box, Chip, Avatar, Tooltip } from '@mui/material';
import utils from 'components/utils';

const KitAccordionSummary = props => {
	const { kit } = props;
	const theme = useTheme();
	const translate = utils.useI18N();
	const orderable = kit.available - kit.committed;

	const chips = [
		{
			label: translate('kit.promo'),
			desc: kit.promoDesc,
			avatar: 'PR',
			condiction: kit.promoCode !== '',
			color: theme.palette.custom.green
		}
	];

	return (
		<Stack direction="row" justifyContent="space-between" alignItems="center" spacing={0} sx={{ width: '100%' }}>
			<Typography variant="titleAccordion" sx={{ width: { xs: '60%', md: '60%', sm: '60%' } }}>
				{kit.name}
			</Typography>
			{/* Icone info */}
			<Stack
				direction="row"
				justifyContent="center"
				alignItems="center"
				spacing={0}
				sx={{
					display: { xs: 'none', md: 'inherit', sm: 'none' },
					width: { xs: '0%', md: '25%', sm: '0%' }
				}}
			>
				{kit.promoCode &&
					chips.map((chip, index) => (
						<Box
							key={index}
							sx={{
								display: chip.condiction ? 'inline-inh' : 'none',
								paddingRight: '5px'
							}}
						>
							<Tooltip title={chip.desc}>
								<Chip
									size="small"
									avatar={
										chip.avatar ? (
											<Avatar
												sx={{
													backgroundColor: '#fff !important',
													borderWidth: '0px',
													color: chip.color + ' !important'
												}}
											>
												{chip.avatar}
											</Avatar>
										) : null
									}
									label={chip.label}
									sx={{
										backgroundColor: chip.color,
										color: '#fff !important',
										margin: '2px',
										borderWidth: '1px',
										borderStyle: 'solid',
										borderColor: chip.color,
										maxWidth: '150px'
									}}
								/>
							</Tooltip>
						</Box>
					))}
			</Stack>
			{/* Kit rimasti */}
			<Stack
				justifyContent="flex-end"
				alignItems="center"
				spacing={0}
				sx={{
					width: { xs: '40%', md: '15%', sm: '40%' }
				}}
			>
				<Typography variant="titleAccordion">{orderable <= 10 ? orderable : ''}</Typography>
				{orderable <= 10 && (
					<Typography variant="text" sx={{ fontSize: '13px', textTransform: 'lowercase' }}>
						{translate('kit.numMaxOrder')}
					</Typography>
				)}
			</Stack>
		</Stack>
	);
};

export default KitAccordionSummary;
